import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtosolapurtaxiservice() {



    const cardData = {




keyword: "Belgaum to Solapur Taxi Service",

headingDescription: "Belgaum Taxi Service provides comfortable and reliable Belgaum to Solapur taxi services for business travel, family visits, medical trips, pilgrimage journeys, and outstation transportation. We offer one-way taxi, round-trip cab, and customized travel options with well-maintained vehicles and professional drivers. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars according to your travel needs. With doorstep pickup, flexible timings, transparent pricing, easy booking, and 24/7 customer support, we ensure a smooth and convenient journey from Belgaum to Solapur. Our cab service is suitable for families, corporate travelers, senior citizens, and groups looking for safe and comfortable interstate travel.",

topPlaces: [
  {
    title: "Solapur",
    description: "Solapur is a major city in Maharashtra known for its textile industry, business activities, religious places, and historical importance. The city attracts travelers for work, education, healthcare, shopping, and pilgrimage purposes. It is also an important connectivity point for nearby destinations in Maharashtra and Karnataka."
  },
  {
    title: "Akkalkot",
    description: "Akkalkot is a famous spiritual destination near Solapur known for the Shri Swami Samarth Maharaj Temple. Devotees from different states visit this holy place throughout the year. The peaceful environment and religious significance make Akkalkot a popular destination for family and pilgrimage trips."
  },
  {
    title: "Pandharpur",
    description: "Pandharpur is one of Maharashtra's most important pilgrimage destinations, famous for the Vitthal Rukmini Temple and Chandrabhaga River. Thousands of devotees visit this sacred town, especially during festivals. It is a preferred destination for religious tours and family pilgrimages."
  },
  {
    title: "Tuljapur",
    description: "Tuljapur is a well-known pilgrimage town famous for the Tulja Bhavani Temple. The temple holds great religious importance and attracts devotees from Maharashtra, Karnataka, and other parts of India. Many travelers combine Solapur and Tuljapur visits in a single tour."
  },
  {
    title: "Bijapur",
    description: "Bijapur is a historic city in Karnataka known for Gol Gumbaz, ancient monuments, and impressive architectural landmarks. The city offers a mix of history, culture, and heritage attractions, making it a popular sightseeing destination."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a famous Maharashtra city known for Mahalaxmi Temple, historical sites, traditional markets, local cuisine, and cultural heritage. It is a popular destination for both religious travelers and tourists exploring Maharashtra."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra with corporate offices, technology parks, universities, and commercial areas. Many travelers prefer private cabs for comfortable business and family travel between Karnataka and Pune."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital known for business districts, airports, entertainment destinations, and famous tourist attractions. Private taxi services provide convenient long-distance connectivity for travelers visiting Mumbai from Solapur."
  },
  {
    title: "Goa",
    description: "Goa is a popular coastal destination famous for beaches, resorts, churches, nightlife, and sightseeing attractions. Travelers often combine Maharashtra trips with Goa holidays for a complete leisure experience."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site known for ancient ruins, temples, royal structures, and historical monuments. It is one of Karnataka's most visited heritage destinations and attracts history lovers and tourists."
  }
],




"services": [
  {
    "name": "Belgaum to Solapur Taxi Service",
    "description": "Book Belgaum to Solapur Taxi Service for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Get Sedan, Ertiga, Innova Crysta, and SUV cab options for business travel, family trips, airport transfers, and personal journeys. Enjoy affordable fares, flexible booking options, doorstep pickup, and a smooth travel experience from Belgaum to Solapur."
  },
  {
    "name": "Belgaum to Solapur Cab",
    "description": "Choose Belgaum to Solapur Cab for convenient and hassle-free intercity transportation with experienced drivers and premium vehicles. Our cab services provide comfortable seating, clean interiors, transparent pricing, and reliable travel solutions for one way trips, round trips, corporate travel, and family journeys."
  },
  {
    "name": "Belgaum to Solapur Taxi",
    "description": "Hire Belgaum to Solapur Taxi for a comfortable long-distance journey with professional chauffeurs and multiple vehicle options. Travel conveniently with Sedan, Ertiga, Innova Crysta, and SUV taxis designed for safe, smooth, and affordable transportation between Belgaum and Solapur."
  },
  {
    "name": "Belgaum to Solapur Cab Service",
    "description": "Get Belgaum to Solapur Cab Service with reliable drivers, clean AC cars, and flexible travel packages. Our cab services are suitable for families, corporate travelers, airport transfers, and outstation passengers looking for comfortable and dependable transportation."
  },
  {
    "name": "Belgaum to Solapur One Way Cab",
    "description": "Book Belgaum to Solapur One Way Cab for affordable single-side travel without return charges. Enjoy fixed pricing, doorstep pickup, comfortable vehicles, and professional drivers for a convenient and economical journey."
  },
  {
    "name": "Belgaum to Solapur One Way Taxi",
    "description": "Choose Belgaum to Solapur One Way Taxi for budget-friendly point-to-point transportation. Get well-maintained vehicles, experienced chauffeurs, flexible pickup locations, and reliable service for personal and business travel."
  },
  {
    "name": "Belgaum to Solapur Cab Booking",
    "description": "Complete Belgaum to Solapur Cab Booking with easy reservations, quick confirmation, and multiple vehicle choices. Select from Sedan, Ertiga, Innova Crysta, and premium cabs according to your travel requirements and passenger capacity."
  },
  {
    "name": "Belgaum to Solapur Taxi Booking",
    "description": "Reserve Belgaum to Solapur Taxi Booking services for safe and comfortable travel. Enjoy transparent fares, professional drivers, timely pickup, and convenient taxi availability for outstation and personal journeys."
  },
  {
    "name": "Belgaum to Solapur Car Rental",
    "description": "Hire Belgaum to Solapur Car Rental services for private chauffeur-driven travel. Choose comfortable vehicles for family trips, business travel, airport transfers, and customized outstation journeys with flexible rental options."
  },
  {
    "name": "Belgaum to Solapur Outstation Cab",
    "description": "Book Belgaum to Solapur Outstation Cab for reliable long-distance transportation with experienced chauffeurs and premium vehicles. Our outstation cabs are perfect for one way travel, round trips, family tours, and corporate journeys."
  },
  {
    "name": "Belgaum to Solapur Innova Crysta Cab",
    "description": "Travel comfortably with Belgaum to Solapur Innova Crysta Cab offering spacious interiors, premium seating, large luggage capacity, and experienced drivers. Ideal for families, groups, business trips, and luxury outstation travel."
  },
  {
    "name": "Belgaum to Solapur Ertiga Cab",
    "description": "Book Belgaum to Solapur Ertiga Cab for affordable and spacious travel with comfortable seating capacity. Perfect for family trips, small groups, airport transfers, and long-distance journeys with professional driver support."
  },
  {
    "name": "Belgaum to Solapur Sedan Cab",
    "description": "Choose Belgaum to Solapur Sedan Cab for economical and comfortable travel with clean AC vehicles and skilled chauffeurs. Sedan cars are suitable for couples, small families, business travelers, and personal trips."
  },
  {
    "name": "Belgaum to Solapur Round Trip Cab",
    "description": "Book Belgaum to Solapur Round Trip Cab for flexible return journeys with affordable packages. Enjoy convenient pickup, comfortable rides, reliable drivers, and customized travel plans for family and business requirements."
  },
  {
    "name": "Belgaum to Solapur Private Taxi",
    "description": "Hire Belgaum to Solapur Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Experience privacy, comfort, flexible timings, and safe transportation throughout your journey."
  },
  {
    "name": "Cheap Belgaum to Solapur Cab",
    "description": "Find Cheap Belgaum to Solapur Cab services with affordable pricing and reliable vehicles. Enjoy budget-friendly transportation without compromising on safety, comfort, driver quality, and travel convenience."
  },
  {
    "name": "Best Belgaum to Solapur Taxi Service",
    "description": "Choose the Best Belgaum to Solapur Taxi Service offering premium vehicles, experienced drivers, competitive fares, and dependable transportation. Our taxi services are designed for comfortable family trips, corporate travel, and outstation journeys."
  },
  {
    "name": "Online Belgaum to Solapur Cab Booking",
    "description": "Book Online Belgaum to Solapur Cab Booking services with quick reservations and instant confirmation. Select your preferred vehicle and enjoy convenient travel planning with reliable customer assistance."
  },
  {
    "name": "Belgaum to Solapur Taxi Fare",
    "description": "Check Belgaum to Solapur Taxi Fare and choose suitable cab options according to your budget and travel needs. Get transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV vehicles without hidden charges."
  },
  {
    "name": "Belgaum to Solapur Car Hire",
    "description": "Hire Belgaum to Solapur Car Hire services for comfortable driver-assisted transportation. Perfect for family tours, corporate travel, airport transfers, and customized long-distance journeys with flexible booking options."
  },
  {
    "name": "Belgaum to Solapur Cab Price",
    "description": "Get affordable Belgaum to Solapur Cab Price with multiple vehicle categories and flexible travel packages. Choose a suitable cab based on your passenger count, comfort preference, and budget."
  },
  {
    "name": "Belgaum to Solapur Family Cab",
    "description": "Book Belgaum to Solapur Family Cab for safe and comfortable travel with spacious vehicles and experienced drivers. Ideal for family vacations, personal visits, and convenient outstation journeys."
  },
  {
    "name": "Belgaum to Solapur Corporate Taxi",
    "description": "Choose Belgaum to Solapur Corporate Taxi services for business travel, employee transportation, and executive journeys. Get professional chauffeurs, punctual service, and comfortable vehicles for corporate requirements."
  },
  {
    "name": "Belgaum to Solapur Airport Transfer",
    "description": "Book Belgaum to Solapur Airport Transfer service for timely pickup and drop transportation. Enjoy comfortable airport travel with professional drivers, clean vehicles, and reliable scheduling support."
  },
  {
    "name": "Belgaum to Solapur Cab Fare",
    "description": "Get competitive Belgaum to Solapur Cab Fare with reliable taxi services and different vehicle choices. Enjoy affordable rates, comfortable rides, and professional travel assistance."
  },
  {
    "name": "Belgaum to Solapur Taxi Near Me",
    "description": "Find Belgaum to Solapur Taxi Near Me for quick cab availability and convenient booking. Get doorstep pickup, clean vehicles, experienced drivers, and reliable outstation taxi services."
  },
  {
    "name": "Belgaum to Solapur Outstation Taxi",
    "description": "Book Belgaum to Solapur Outstation Taxi for safe and comfortable long-distance travel. Our taxis provide flexible schedules, professional chauffeurs, and affordable travel packages."
  },
  {
    "name": "Belgaum to Solapur Travel by Cab",
    "description": "Travel from Belgaum to Solapur by Cab with comfortable seating, experienced drivers, and reliable service. Enjoy a smooth journey with premium vehicles suitable for families, corporate travelers, and individual passengers."
  }
],
"tableData": [
  ["Belgaum to Solapur Taxi Service", "Belgaum to Solapur Cab"],
  ["Belgaum to Solapur Taxi", "Belgaum to Solapur Cab Service"],
  ["Belgaum to Solapur One Way Cab", "Belgaum to Solapur One Way Taxi"],
  ["Belgaum to Solapur Cab Booking", "Belgaum to Solapur Taxi Booking"],
  ["Belgaum to Solapur Car Rental", "Belgaum to Solapur Outstation Cab"],
  ["Belgaum to Solapur Innova Crysta Cab", "Belgaum to Solapur Ertiga Cab"],
  ["Belgaum to Solapur Sedan Cab", "Belgaum to Solapur Round Trip Cab"],
  ["Belgaum to Solapur Private Taxi", "Cheap Belgaum to Solapur Cab"],
  ["Best Belgaum to Solapur Taxi Service", "Online Belgaum to Solapur Cab Booking"],
  ["Belgaum to Solapur Taxi Fare", "Belgaum to Solapur Car Hire"],
  ["Belgaum to Solapur Cab Price", "Belgaum to Solapur Family Cab"],
  ["Belgaum to Solapur Corporate Taxi", "Belgaum to Solapur Airport Transfer"],
  ["Belgaum to Solapur Cab Fare", "Belgaum to Solapur Taxi Near Me"],
  ["Belgaum to Solapur Outstation Taxi", "Belgaum to Solapur Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Solapur Taxi Service",
    WhyChoosedescription: "Travel from Belgaum to Solapur with a dependable taxi service offering comfortable vehicles, experienced drivers, and flexible travel options for business, family, and personal journeys."
  },
  {
    WhyChooseheading: "Direct City-to-City Cab Travel",
    WhyChoosedescription: "Enjoy a smooth point-to-point journey with convenient pickup from your preferred location in Belgaum and direct drop service in Solapur."
  },
  {
    WhyChooseheading: "Wide Range of Cab Options",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on your passenger count, luggage space, and comfort preferences."
  },
  {
    WhyChooseheading: "Suitable for Business & Personal Trips",
    WhyChoosedescription: "Our Belgaum to Solapur taxis are ideal for corporate travel, family visits, medical appointments, educational trips, and personal transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Professional chauffeurs ensure safe driving, timely pickup, and a comfortable journey with proper knowledge of highway routes."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Plans",
    WhyChoosedescription: "Select a one-way cab for direct travel or book a round-trip taxi according to your schedule and return requirements."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Outstation Travel",
    WhyChoosedescription: "Well-maintained cars with clean interiors and spacious seating provide a relaxed travel experience from Belgaum to Solapur."
  },
  {
    WhyChooseheading: "Simple Cab Booking Process",
    WhyChoosedescription: "Get quick assistance for vehicle selection, fare details, and taxi availability to arrange your Belgaum to Solapur journey easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Solapur Taxi Service?",
    answer: "Yes, we provide Belgaum to Solapur taxi services with comfortable vehicles and professional drivers for outstation travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Solapur?",
    answer: "Yes, one-way cab services are available for passengers who need direct transportation between Belgaum and Solapur."
  },
  {
    question: "Which vehicles are available for Belgaum to Solapur travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your travel requirements."
  },
  {
    question: "Is Belgaum to Solapur taxi suitable for family travel?",
    answer: "Yes, comfortable and spacious vehicles are available for families, senior citizens, and groups travelling between Belgaum and Solapur."
  },
  {
    question: "Can I book a return cab from Solapur to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible timings according to your travel plan."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Solapur?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Solapur taxi service available 24/7?",
    answer: "Yes, taxi booking assistance is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Solapur Taxi?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Desai",
    feedback: "The Belgaum to Solapur taxi service was smooth and comfortable. The driver was punctual, and the vehicle was clean throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Patil",
    feedback: "We booked a cab for family travel to Solapur and had a great experience. The service was reliable, and the journey was very comfortable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Solapur Taxi Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-solapur-taxi-service.webp",
  "description":
    "Book Belgaum to Solapur Taxi Service with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Solapur with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, airport transfers, pilgrimage tours, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-solapur-taxi-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Belgaum to Solapur Taxi Service | One Way Cab | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Solapur Taxi Service with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs for affordable, safe, and comfortable outstation travel from Belgaum to Solapur with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Belgaum to Solapur Taxi Service, Belgaum to Solapur Cab, Belgaum to Solapur Taxi, Belgaum to Solapur Cab Service, Belgaum to Solapur One Way Cab, Belgaum to Solapur One Way Taxi, Belgaum to Solapur Cab Booking, Belgaum to Solapur Taxi Booking, Belgaum to Solapur Car Rental, Belgaum to Solapur Outstation Cab, Belgaum to Solapur Innova Crysta Cab, Belgaum to Solapur Ertiga Cab, Belgaum to Solapur Sedan Cab, Belgaum to Solapur Round Trip Cab, Belgaum to Solapur Private Taxi, Cheap Belgaum to Solapur Cab, Best Belgaum to Solapur Taxi Service, Online Belgaum to Solapur Cab Booking, Belgaum to Solapur Taxi Fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtosolapurtaxiservice ;